module.exports = __webpack_public_path__ + "img/jobs_i4.4565cda1.png";